import { useState } from "react"

import { Button } from "@/components/ui/Button"

import { DeleteAccountDialog } from "../../delete-account/components/DeleteAccountDialog"
import { DeleteEmailSupportDialog } from "../../delete-account/components/DeleteEmailSupportDialog"
import { LoadingDialog } from "../../pricing/components/contact-partnership-dialog-components/LoadingDialog"

import type { DeleteClick } from "../StudentProfile"

interface DeleteAccountButtonProps {
  deleteOptions: string[]
  errorMessage?: string | null
  onDeleteClick: () => Promise<DeleteClick | void>
  onConfirmDelete: (deleteReason: string) => Promise<void>
}

export function DeleteAccountButton({
  deleteOptions,
  errorMessage,
  onDeleteClick,
  onConfirmDelete,
}: DeleteAccountButtonProps) {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)
  const [showEmailSupportDialog, setShowEmailSupportDialog] = useState(false)
  const [showLoadingDialog, setShowLoadingDialog] = useState(false)
  const [deleteReason, setDeleteReason] = useState<string>("")

  async function handleDeleteAccountClick(): Promise<void> {
    setShowLoadingDialog(true)
    try {
      const result = await onDeleteClick()
      if (result === "email-support") {
        setShowEmailSupportDialog(true)
      } else if (result === "delete") {
        setShowDeleteDialog(true)
      }
    } finally {
      setShowLoadingDialog(false)
    }
  }

  return (
    <>
      <Button variant="destructive" onClick={handleDeleteAccountClick}>
        Delete Account
      </Button>

      {showLoadingDialog && (
        <LoadingDialog
          message="Checking assignments..."
          onClose={() => setShowLoadingDialog(false)}
        />
      )}

      {showDeleteDialog && (
        <DeleteAccountDialog
          isOpen={showDeleteDialog}
          deleteOptions={deleteOptions}
          errorMessage={errorMessage}
          deleteReason={deleteReason}
          onClose={() => setShowDeleteDialog(false)}
          onSubmit={(reason) => {
            setDeleteReason(reason)
          }}
          onConfirmDelete={onConfirmDelete}
        />
      )}

      {showEmailSupportDialog && (
        <DeleteEmailSupportDialog
          isOpen={showEmailSupportDialog}
          onClose={() => setShowEmailSupportDialog(false)}
        />
      )}
    </>
  )
}
